import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('rps_admin_token');
    if (!token) {
      setLoading(false);
      return;
    }
    axios
      .get(`${API_URL}/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setAdmin(res.data))
      .catch(() => {
        localStorage.removeItem('rps_admin_token');
        setAdmin(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback((adminData, token) => {
    localStorage.setItem('rps_admin_token', token);
    setAdmin(adminData);
  }, []);

  const logout = useCallback(async () => {
    const token = localStorage.getItem('rps_admin_token');
    if (token) {
      try {
        await axios.post(
          `${API_URL}/admin/logout`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (_) {
        // ignore
      }
    }
    localStorage.removeItem('rps_admin_token');
    setAdmin(null);
  }, []);

  const value = useMemo(
    () => ({ admin, isAuthenticated: !!admin, loading, login, logout }),
    [admin, loading, login, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};
